import { render, staticRenderFns } from "./Cancellations.vue?vue&type=template&id=c6babc1c&scoped=true&"
import script from "./Cancellations.vue?vue&type=script&lang=js&"
export * from "./Cancellations.vue?vue&type=script&lang=js&"
import style0 from "./Cancellations.vue?vue&type=style&index=0&id=c6babc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6babc1c",
  null
  
)

export default component.exports